import ManagementModule from './ManagementScreen.module.scss'
import CloseIcon from '@mui/icons-material/Close'
import Switch2 from '../Switch/Switch'
import { _fields_of_user_data_in_mypage } from '../../localConstant'
import { useUserDataContext } from '../../context/AuthContext'

function SchoolUsageModal({
  isOpen,
  onOpen,
  onClose,
  selectedPrompt,
  handleInputAvailableAllSchoolsChange,
  searchQuery,
  setSearchQuery,
  handleSelectAll,
  handleDeselectAll,
  filteredIds,
  schoolIdName,
  selectedIds,
  handleCheckboxChange
}) {
  const UserData = useUserDataContext()
  return (
    <>
      <div className={ManagementModule['section-title-group']}>
        <p className={ManagementModule['label']}>
          {UserData.role === 'admin' ? 'スクールのモード利用設定' : '子スクールのモード利用設定'}
        </p>
        <button className={ManagementModule['copy']} onClick={onOpen}>
          設定
        </button>
      </div>
      {isOpen && (
        <div
          className={ManagementModule['modal-overlay']}
          style={{
            zIndex: 10,
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0
          }}
          onClick={(e) => {
            if (e.target === e.currentTarget) {
              onClose()
            }
          }}
        >
          <div className={ManagementModule['modal']} style={{ zIndex: 11 }}>
            <div className={ManagementModule['modal-content']} onClick={(e) => e.stopPropagation()}>
              <CloseIcon className={ManagementModule['close-modal']} onClick={onClose} />
              <h3 className={ManagementModule['section-title-in-modal']}>子スクールのモード利用設定</h3>
              <p className={ManagementModule['section-explanation']}>
                ※各子スクールがこのモードを利用できるかどうかを設定します。
              </p>
              <div className={ManagementModule['prompt-input3-modal']}>
                <div className={ManagementModule['prompt-input-fields-container4']}>
                  <span className={ManagementModule['sub-field']}>全子スクールに対してモードを利用可能にする</span>
                  <Switch2
                    checked={selectedPrompt.availableAllSchools}
                    onChange={() => handleInputAvailableAllSchoolsChange(selectedPrompt.availableAllSchools)}
                  />
                </div>
              </div>
              {selectedPrompt.availableAllSchools === false && (
                <>
                  <div className={ManagementModule['search-container']}>
                    <input
                      className={ManagementModule['search']}
                      type="text"
                      placeholder="検索..."
                      value={searchQuery}
                      onChange={(e) => setSearchQuery(e.target.value)}
                    />
                    <button className={ManagementModule['rectangle']} onClick={handleSelectAll}>
                      全選択
                    </button>
                    <button className={ManagementModule['rectangle']} onClick={handleDeselectAll}>
                      全解除
                    </button>
                  </div>
                  <ul className={ManagementModule['doc-list']}>
                    {(filteredIds || []).map(
                      (id) =>
                        schoolIdName[id] && (
                          <li className={ManagementModule['doc-list']} key={id}>
                            <div className={ManagementModule['doc-list']}>
                              <Switch2 value={id} checked={selectedIds.includes(id)} onChange={handleCheckboxChange} />
                              {schoolIdName[id]}
                            </div>
                          </li>
                        )
                    )}
                  </ul>
                </>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  )
}

export default SchoolUsageModal
